<section
  class="view-title"
  (click)="handleTitleClick()"
  #title
  [ngClass]="{
    'view-title--clickable': (chapterCount$ | async) > 1 && menuEnabled,
    'view-title--center': alignTitle === 'center',
    'view-title--large': size === 'large'
  }">
    <!-- story title -->
    <h1
      id="view-title"
      class="view-title__story"
      [ngClass]="{'view-description__story-title--large': !chapterTitle}"
      *ngIf="storyTitle && (storyTitle != chapterTitle)">
      {{ storyTitle }}
    </h1>

    <!-- chapter title -->
    <h1 class="view-title__chapter" id="view-title">
      <span *ngIf="(chapterCount$ | async) > 1 && menuEnabled">{{ (chapterIndex$ | async) + 1 }}.</span>
      {{ chapterTitle | textNormalize }}
      <app-icon icon="caret-down" *ngIf="(chapterCount$ | async) > 1 && menuEnabled"></app-icon>
    </h1>
</section>
